import React from 'react'
import SetMerchant from './setMerchant'

import './style/merchantBox.less'
const MerchantBox = (props) => {
  return (
    <div className = "merchantBox">
      <div className = "header">
        <h2>商铺设置</h2>
      </div>
      <div className = "content">
        <SetMerchant newSet />
      </div>
    </div>
  )
}

export default MerchantBox